import { memo, useId } from "react";

const Checkbox = props => {
    const {
        changeHandler,
        value
    } = props;

    const elId = useId();
    return (
        <label htmlFor={elId} className={`p-checkbox${value ? " checked" : ""}`}>
            <input type="checkbox" defaultChecked={!!value} id={elId} onChange={changeHandler} />
            <span></span>
        </label>
    )
}

export default memo(Checkbox);